"use strict";import{tag as e}from"../custom-tag.js";export function loadingIcon({height:a=16,width:l=16,hidden:t=!1,title:r="Loading"}={}){return e`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <g fill="currentColor" clip-path="url(#loading_svg__clip0_8047_6156)">
        <path
          d="M12.562 5.614a2.807 2.807 0 1 0 0-5.614 2.807 2.807 0 0 0 0 5.614M12.563 24a1.684 1.684 0 1 0 0-3.368 1.684 1.684 0 0 0 0 3.368M5.665 8.19a2.527 2.527 0 1 0 0-5.053 2.527 2.527 0 0 0 0 5.053M19.46 20.861a1.404 1.404 0 1 0 0-2.807 1.404 1.404 0 0 0 0 2.807M2.808 14.807a2.245 2.245 0 1 0 0-4.49 2.245 2.245 0 0 0 0 4.49m19.508-1.124a1.122 1.122 0 1 0 0-2.244 1.122 1.122 0 0 0 0 2.244M4.276 18.07a1.963 1.963 0 0 0 0 2.779 1.963 1.963 0 0 0 2.778 0 1.963 1.963 0 0 0 0-2.779 1.955 1.955 0 0 0-2.778 0M19.46 6.505a.842.842 0 1 0 0-1.683.842.842 0 0 0 0 1.683"
        />
      </g>
    </svg>
  `}
//# sourceMappingURL=loading.js.map
